<div [attr.data-test]="dataTest()" #instance="ngbDropdown" autoClose="outside" ngbDropdown placement="bottom-right top-right">
  <button
    [attr.aria-expanded]="instance._open"
    [ngClass]="{ 'border-0': !hasBorder() }"
    [disabled]="!isEnabled()"
    class="btn btn-icon btn-md btn-secondary--blue"
    type="button"
    ngbDropdownToggle
  >
    <i aria-hidden="true" class="fa-solid fa-ellipsis-vertical"></i>
  </button>
  <div ngbDropdownMenu>
    <ng-content select="[slot='options']" />
    @if (hasOptions()) {
      @for (option of options(); track $index) {
        <button (click)="option.clickFunc()" ngbDropdownItem>
          {{ option.label | translate }}
        </button>
      }
    }
  </div>
</div>
